<script context="module" lang="ts">
    import {MetricTypes} from "../index";

    const groups = [
        {key: 'count', label: 'Count', types: [MetricTypes.IS_EMPTY, MetricTypes.IS_NOT_EMPTY, MetricTypes.COUNT]},
        {
            key: 'percentage',
            label: 'Percentage',
            types: [MetricTypes.IS_EMPTY_PERCENTAGE, MetricTypes.IS_NOT_EMPTY_PERCENTAGE, MetricTypes.COUNT_PERCENTAGE]
        },
        {key: 'date', label: 'Date', types: [MetricTypes.DATE_RANGE, MetricTypes.DATE_MIN, MetricTypes.DATE_MAX]},
        {
            key: 'calculations',
            label: 'Calculations',
            types: [MetricTypes.MIN, MetricTypes.MAX, MetricTypes.AVG, MetricTypes.SUM, MetricTypes.RANGE]
        },
    ];

    const allGroupedTypes: string[] = groups.flatMap(g => g.types);

    const dynamicGroupKey: Record<string, string> = {
        'COUNT': 'count',
        'COUNT_PERCENTAGE': 'percentage',
    };

    const getBaseType = (value: string): string => {
        const index = value.indexOf(':');
        return index !== -1 ? value.substring(0, index) : value;
    };
</script>

<script lang="ts">
    import Menu from "./Menu.svelte";
    import {MetricOption} from "../index";
    import {getMenuLabel} from "../utils";

    export let metrics: MetricOption[] = [];

    $: dynamicMetrics = metrics.filter(m => !allGroupedTypes.includes(m.value));

    $: dynamicByGroup = dynamicMetrics.reduce<Record<string, MetricOption[]>>((acc, m) => {
        const baseType = getBaseType(m.value);
        const groupKey = dynamicGroupKey[baseType];
        if (groupKey) {
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(m);
        }
        return acc;
    }, {});

    $: menuItems = [
        {key: '', label: 'None'},
        ...groups
            .map(group => {
                const staticChildren = group.types
                    .filter(type => metrics.some(m => m.value === type))
                    .map(type => ({key: type, label: getMenuLabel(type, metrics)}));

                const dynamicChildren = (dynamicByGroup[group.key] ?? [])
                    .map(m => ({key: m.value, label: m.menu_label}));

                const children = dynamicChildren.length > 0 && staticChildren.length > 0
                    ? [...staticChildren, {key: 'divider', label: '', divider: true}, ...dynamicChildren]
                    : [...staticChildren, ...dynamicChildren];

                return {
                    key: group.key,
                    label: group.label,
                    children
                };
            })
            .filter(group => group.children.length > 0),
    ];

</script>

<Menu items={menuItems} on:click/>
